import { axiosGet, axiosPost } from './axiosService';

const baseUnsubscribeURI = 'Unsubscribe';

export class SubscriptionService {
	checkSubscriptionStatus(email) {
		return axiosGet({ email }, baseUnsubscribeURI + '/status');
	}

	subscribe(email) {
		return axiosPost(null, baseUnsubscribeURI + `/subscribe?email=${encodeURIComponent(email)}`);
	}

	unsubscribe(email) {
		return axiosGet({ email }, baseUnsubscribeURI);
	}
}

